import { FunctionComponent, useState, useRef } from "react";
import styles from "./ChangeStageModal.module.css";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { changeLeadsStage } from "../../../Services/organizations";
import { showSnackbarAction } from "../../../Redux/actions";

// -------------------------------------------------------------
// Props expected for ChangeStageModal
// -------------------------------------------------------------
type props = {
  open: boolean;
  close: () => void;
};

// -------------------------------------------------------------
// ChangeStageModal Component
// -------------------------------------------------------------
const ChangeStageModal: FunctionComponent<props> = ({ open, close }) => {
  // Reference to textarea input (optional, but available)
  const leadsRef: any = useRef();

  // Redux dispatcher
  const dispatcher = useDispatch();

  // State: loader visibility
  const [load, setLoad] = useState(false);

  // State: lead IDs entered by user
  const [leads, setLeads] = useState("");

  // -------------------------------------------------------------
  // Handle Save Button Click
  // -------------------------------------------------------------
  const onSave = () => {
    // Validate input
    if (leads === "") {
      dispatcher(showSnackbarAction("Please Enter Lead Ids", "error"));
    } else {
      setLoad(true);
      changeLeadsStage(leads.split(","), dispatcher, (data) => setLoad(data));
    }
  };

  // -------------------------------------------------------------
  // Modal UI + Content
  // -------------------------------------------------------------
  return (
    <Modal
      isOpen={open}
      className={styles.parent}
      overlayClassName={styles.overlay}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      {/* Loader displayed while saving */}
      {load && <Loading />}

      {/* Modal Header */}
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Change Stage</p>
      </div>

      {/* Textarea to enter comma-separated Lead IDs */}
      <textarea
        style={{ width: "90%", resize: "none", marginTop: "57px" }}
        rows={4}
        cols={10}
        placeholder={"Enter Lead Ids"}
        ref={leadsRef}
        onChange={(e) => setLeads(e.target.value)}
        value={leads}
      ></textarea>

      {/* Buttons: Cancel + Save */}
      <div className={styles.buttonView}>
        <button className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={() => onSave()}>
          Save
        </button>
      </div>
    </Modal>
  );
};

// -------------------------------------------------------------
// Redux: Map state to props (if needed later)
// -------------------------------------------------------------
const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
  };
};

export default connect(mapStateToProps)(ChangeStageModal);
